import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import af9f7626305ca906a52fae9202514556db from "./generated-b0e661f9-85ab-4f89-8b2a-fa9f7f079d93.json";

import a20f8b2073bf41ef10bb5f4f7e1eaf858b from "./generated-1e8f6e95-e455-44d7-8abc-c62b2901f359.json";

import a035614025dd3de2964daf0ea43c0d9f8b from "./generated-33105116-3107-4a5f-8b3e-2fe91fd7eb0f.json";

import af8477c3384be0de6d48e2bb60e3003c5b from "./generated-a869357c-2786-4493-a467-0b56e91a2b04.json";

import af5f1dba41439843c06d375a4a9ef32d8b from "./generated-253b1b9b-1c68-4d49-aa80-36f45ea018c2.json";

import a5e9cb2e930fff713af33949c97641b2cb from "./generated-2d1c2c6f-98ae-48ef-92ce-3f5a5527fffd.json";

import a7ef4f5c1bf9c5153400c60faefa9dc37b from "./generated-b7ad5f19-4df6-4b03-b3d6-244cfba9282f.json";

import a09686838b5a9d69433351852123361b1b from "./generated-c868542b-d036-4604-9b34-f889d0fd9c82.json";

import a164495494c8e8b7c4cbf536a8ab797e2b from "./generated-827bd5c3-0033-448a-aa5b-30580334bbdc.json";

import a2b78d91166723d75fb5ca099de6dc812b from "./generated-1be55c98-d313-422f-b524-4fd11ed96ea6.json";

import ace82a5990d352146ae5590d2bbdc86ddb from "./generated-cfe5fe7b-867c-40ff-a116-e7fb71e5d724.json";

import a8a47b0cd88e3481a7759213e9c36fba2b from "./generated-39352394-5b4d-4e47-a177-c4a82a4e58b7.json";

import a96d311cef98324011308c389925588e6b from "./generated-4dd71ada-f627-4b7b-9895-20706874d12f.json";

import afbdfab1e80b67091a9afc6208ff13eccb from "./generated-2cc6b5ca-0297-4c3c-b4a3-6ef96a948937.json";

import a7135628fad3235326e0cb466159c5dd2b from "./generated-91942ea9-3678-45ed-83a4-bfca541e945f.json";

import a4b57d2ff0f1ced88eedd0e84c29b9464b from "./generated-4a5027e7-471e-48de-8aa4-4f8f71368849.json";

import a7895871330ee993b8bb2b8595680209ab from "./generated-d7ac53ca-cb75-4b10-94ac-716f45ad1860.json";

import a3d6ada4cb62b7b9be42ebbab2cdd9d7db from "./generated-aa2f7b7b-ccc8-4005-a186-72f4a476f8ef.json";

import ad71f8bea5d90688df3b7f7073570cae4b from "./generated-1aa1b34b-9bc2-486f-bbec-b270440ef76b.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(af9f7626305ca906a52fae9202514556db);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a20f8b2073bf41ef10bb5f4f7e1eaf858b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a035614025dd3de2964daf0ea43c0d9f8b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(af8477c3384be0de6d48e2bb60e3003c5b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(af5f1dba41439843c06d375a4a9ef32d8b);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5e9cb2e930fff713af33949c97641b2cb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a7ef4f5c1bf9c5153400c60faefa9dc37b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a09686838b5a9d69433351852123361b1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(a164495494c8e8b7c4cbf536a8ab797e2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a2b78d91166723d75fb5ca099de6dc812b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(ace82a5990d352146ae5590d2bbdc86ddb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a8a47b0cd88e3481a7759213e9c36fba2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(a96d311cef98324011308c389925588e6b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(afbdfab1e80b67091a9afc6208ff13eccb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a7135628fad3235326e0cb466159c5dd2b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(a4b57d2ff0f1ced88eedd0e84c29b9464b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a7895871330ee993b8bb2b8595680209ab);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a3d6ada4cb62b7b9be42ebbab2cdd9d7db);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ad71f8bea5d90688df3b7f7073570cae4b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ace82a5990d352146ae5590d2bbdc86ddb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */